import { Link } from 'react-router-dom';

const Reporting = () => {
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>Reporting</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>Reporting</h2>
				<div className="divider" />
				<ul className="text-lg menu">
					<li>
						<Link className="link" to="/reporting/reports">
							Reports
						</Link>
					</li>
					<li>
						<Link className="link" to="/reporting/dashboard">
							Dashboard
						</Link>
					</li>
				</ul>
			</div>
		</>
	);
};

export default Reporting;
